import { HITSEARCH } from './Base';

export const onGetRequest = (params = {}, cb) => ({ params, type: HITSEARCH.GET_REQUEST, cb });
export const onGetSuccess = (payload = {}, cb) => ({ payload, type: HITSEARCH.GET_SUCCESS, cb });
export const onGetFailure = (payload = {}, cb) => ({ payload, type: HITSEARCH.GET_FAILURE, cb });

export const onGetNextRequest = (params = {}, cb) => ({ params, type: HITSEARCH.GET_NEXT_REQUEST, cb });
export const onGetNextSuccess = (payload = {}, cb) => ({ payload, type: HITSEARCH.GET_NEXT_SUCCESS, cb });
export const onGetNextFailure = (payload = {}, cb) => ({ payload, type: HITSEARCH.GET_NEXT_FAILURE, cb });

export const onResetRequest = (payload = {}) => ({ payload, type: HITSEARCH.RESET_REQUEST });
